/**
 * Formatea un número con separador de miles.
 * @param {number|string} value - Número a formatear.
 * @param {string} locale - Configuración local, por defecto 'es-PY' (1.000).
 * @param {number} minFractionDigits - Cantidad mínima de decimales.
 * @returns {string} Número formateado o string vacío si no es válido.
 */
export function formatNumber(
  value,
  locale = "es-PY",
  minFractionDigits = 0
) {
  if (value === null || value === undefined || value === "") return "";

  // Convertir a string y limpiar separadores de miles
  const cleaned = String(value).replace(/\./g, "").replace(",", ".");

  const num = Number(cleaned);
  if (isNaN(num)) return "";

  return num.toLocaleString(locale, {
    minimumFractionDigits: minFractionDigits,
  });
}
